import livestreamService from '../../services/livesession/LivestreamService';
import liveSessioner from '../../services/livesession/LiveSessioner';
import apiReader from '../../store/readHelpers/ApiReader';

// Maps the component state and props into deduced props, that way we keep testable logic outside of the component which
// stays really pure (status-free and service-free)
const mapStateToProps = (state) => {
    const shouldShowCandidateReconnecting = !apiReader.isOnline();

    return {
        mirrorWebcamStream: liveSessioner.getGrantedStream(),
        proctorIds: livestreamService.resolveCallingProctors(state.livestream),
        shouldShowCandidateReconnecting,
    };
};

const liveSessionCallSelector = {
    mapStateToProps,
};

export default liveSessionCallSelector;
